import type { FC } from 'react';
import { ProductType } from '../../../products/types';
import SaleIcon from '@wix/da-ds/pkg/Icons/24x24/Sale';
import PremiumDownloadIcon from '@wix/da-ds/pkg/Icons/24x24/PremiumDownload';
import PremiumGalleryIcon from '@wix/da-ds/pkg/Icons/24x24/PremiumGallery';
import CommissionIcon from '@wix/da-ds/pkg/Icons/24x24/CommissionBrush';
import TierIcon from '@wix/da-ds/pkg/Icons/24x24/Tier';
import ResaleIcon from '@wix/da-ds/pkg/Icons/24x24/Resale';
import OriginalIcon from '@wix/da-ds/pkg/Icons/24x24/OriginalBrush';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

import s from './ProductTypeIcon.scss';

interface Props {
  productType: ProductType;
  size?: number;
}

const ProductTypeIcon: FC<Props> = ({ productType, size = 64 }) => {
  return (
    <div className={s['icon']}>
      <div className={s[`icon-${productType}`]} style={{ width: size, height: size }}>
        {productType === ProductType.Exclusive && (
          <SaleIcon size={IconSize.MEDIUM} disableDefaultColors />
        )}
        {productType === ProductType.ExclusiveResale && (
          <ResaleIcon size={IconSize.MEDIUM} disableDefaultColors />
        )}
        {productType === ProductType.PremiumDownload && (
          <PremiumDownloadIcon size={IconSize.MEDIUM} disableDefaultColors />
        )}
        {productType === ProductType.PremiumGallery && (
          <PremiumGalleryIcon size={IconSize.MEDIUM} disableDefaultColors />
        )}
        {productType === ProductType.Commission && (
          <CommissionIcon size={IconSize.MEDIUM} disableDefaultColors />
        )}
        {productType === ProductType.Tier && (
          <TierIcon size={IconSize.MEDIUM} disableDefaultColors />
        )}
        {productType === ProductType.Original && (
          <OriginalIcon size={IconSize.MEDIUM} disableDefaultColors />
        )}
      </div>
    </div>
  );
};
ProductTypeIcon.displayName = 'ProductTypeIcon';

export default ProductTypeIcon;
